import React, { useState, useEffect } from "react";
import { Table, Button, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { Layout } from "~/components/UI";
import { ModuleHeader } from '~/components/ModuleHeader';
import * as plgFormsActions from "~/containers/Plugins/Forms/actions";
import DrawerForm from "~/containers/Plugins/Forms/DrawerForm";
import { tableColumns } from "~/containers/Plugins/Forms/tableColumns";

var PageForms = function() {
  var dispatch = useDispatch();
  var settings = useSelector(function(state) { return state.settings; });
  var plgForms = useSelector(function(state) { return state.plgForms; });
  var forms = plgForms.forms;
  var isLoading = plgForms.isLoading;

  var selectedState = useState(null);
  var selected = selectedState[0];
  var setSelected = selectedState[1];

  useEffect(function() {
    dispatch(plgFormsActions.load());
  }, []);

  return React.createElement(Layout, null,
    React.createElement('div', null,
      React.createElement(ModuleHeader, {
        breadcrumbs: ['Plugins', 'Formulários'],
        title: 'Formulários',
        actions: React.createElement(Button, {
          icon: 'plus',
          shape: 'circle',
          onClick: function() {
            setSelected({
              id: null,
              acquisition_id: null,
              redirect_to_whatsapp: null
            });
          }
        })
      }),
      React.createElement(Table, {
        rowKey: 'id',
        dataSource: forms,
        bordered: true,
        pagination: false,
        loading: isLoading,
        columns: tableColumns(
          settings,
          function(id) { dispatch(plgFormsActions.remove(id)); },
          function(data) { setSelected(data); }
        )
      }),
      selected !== null && React.createElement(DrawerForm, {
        onClose: function() { setSelected(null); },
        data: selected
      })
    )
  );
};

export default PageForms;
